import React from 'react';

interface RevokeConfirmationModalProps {
  isOpen: boolean;
  integrationName?: string;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  isLoading: boolean;
}

const RevokeConfirmationModal: React.FC<RevokeConfirmationModalProps> = ({
  isOpen,
  integrationName,
  onClose,
  onConfirm,
  isLoading
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-5 border w-full max-w-md shadow-lg rounded-md bg-white">
        <div className="mt-3">
          <div className="flex items-center justify-center w-12 h-12 mx-auto bg-red-100 rounded-full mb-4">
            <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          
          <h3 className="text-lg font-medium text-gray-900 text-center mb-2">
            Revoke Integration
          </h3>
          
          <p className="text-sm text-gray-500 text-center mb-6">
            Are you sure you want to revoke the {integrationName ? `"${integrationName}"` : ''} integration? 
            This action cannot be undone and will disconnect the integration immediately.
          </p>
          
          <div className="flex justify-center space-x-3">
            <button
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md text-sm font-medium focus:outline-none focus:ring-2 focus:ring-red-500 disabled:opacity-50"
              disabled={isLoading}
            >
              {isLoading ? 'Revoking...' : 'Revoke Integration'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RevokeConfirmationModal;
